const config = {};
config.siteURL = "https://trackmovies.net";
config.siteName = "Track Movies";
config.tmdbAPIKeys = [
    "40dc6df69e40fd1739c49af822bb83fd",
    "cfe422613b250f702980a3bbf9e90716",
    "a891a43144ff454381c26c74adc91c1f",
    "a70dbfe19b800809dfdd3e89e8532c9e"
];
config.niceAPI = `https://api.themoviedb.org/3/movie/__ID?api_key=${
    config.tmdbAPIKeys[
        Math.round(Math.floor(Math.random() * config.tmdbAPIKeys.length))
    ]
}&append_to_response=videos,credits,similar`;
config.tmdbAPISearch = `https://api.themoviedb.org/3/search/movie?query=TO_SEARCH&api_key=${
    config.tmdbAPIKeys[
        Math.round(Math.floor(Math.random() * config.tmdbAPIKeys.length))
    ]
}&page=__PAGE_NUM`;
config.tmdbAPIPosterLink = "https://image.tmdb.org/t/p/w342POSTER_LINK";
config.tmdbAPIBackdropLink = "https://image.tmdb.org/t/p/w780BACKDROP_LINK";
config.tmdbAPIStillImagesLink = "https://image.tmdb.org/t/p/w92STILL_IMAGE";
config.tmdbAPI = `https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=${
    config.tmdbAPIKeys[
        Math.round(Math.floor(Math.random() * config.tmdbAPIKeys.length))
    ]
}&page=__PAGE_NUM`;
config.fetchUpcomingMoviesAPIEndpoint = `https://api.themoviedb.org/3/movie/upcoming?sort_by=popularity.desc&api_key=${
    config.tmdbAPIKeys[
        Math.round(Math.floor(Math.random() * config.tmdbAPIKeys.length))
    ]
}`;
config.quoteAPIEndpoint =
    "https://andruxnet-random-famous-quotes.p.mashape.com/?cat=movies&count=1";

config.brokenImages = {
    poster: "https://i.imgur.com/P8LAfJ8.png",
    backdrop: "https://i.imgur.com/RnMMnNz.png"
};
module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js